import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Auth from './Auth';
import { supabase } from './supabase';
import reportWebVitals from './reportWebVitals';

function Root() {
  const [session, setSession] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setChecking(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (checking) return React.createElement('div', {
    style: { display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#0F1117', color:'#fff', fontFamily:'Inter, sans-serif', fontSize:16 }
  }, 'Loading...');

  return session ? React.createElement(App, { session }) : React.createElement(Auth);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(React.createElement(React.StrictMode, null, React.createElement(Root)));

reportWebVitals();